/**
 * Fiskal Cloud Archive Export API
 * # Overview  Archive export API is used for * exporting imported assets in DSFinV-k cash register formats * exporting imported assets in RAW format - that means as they were imported  # Generic workflow  ## Export workflow We can export data via:  ``` curl \\ --request POST \\ --header \'Content-Type: application/json\' \\ --data-raw \'{\"exportType\": \"DSFINVK\", \"importIds\": [\"1\", \"2\"]}\' \\ https://fiskal.cloud/archiving-export-api/business-premises/{businessPremisesId}/exports ```  We receive `exportId`:  ``` {   \"id\": \"4dc75f64-5717-3214-b3fc-2c963f66aca7\" } ```  Then, we can keep polling the state until it\'s ready:  ``` curl \\ --request GET \\ https://fiskal.cloud/archiving-export-api/exports/4dc75f64-5717-3214-b3fc-2c963f66aca7 ```  ``` {   \"id\": \"3fa85f64-5717-4562-b3fc-2c963f66afa6\",   \"status\": \"PENDING\",   \"requested\": \"2020-04-20T11:47:05.471Z\" } ```  Once it\'s ready, we will get the URL where we can download the export: ``` {   \"id\": \"3fa85f64-5717-4562-b3fc-2c963f66afa6\",   \"status\": \"READY\",   \"requested\": \"2020-04-20T11:47:05.471Z\",   \"result\": {     \"url\": \"https://some-storage.lets-say.azure.com/storage/download-my-file\"   } } ``` 
 *
 * The version of the OpenAPI document: 0.18.0
 * Contact: info@deutsche-fiskal.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ExportStatusEnumDTO } from './export-status-enum-dto';
import { ExportResultDTO } from './export-result-dto';


export interface ProceduralDocumentationExportDTO { 
    /**
     * Internal identifier of procedural documentation export
     */
    id?: string;
    /**
     * Internal identifier of business premises (location of store)
     */
    businessPremisesId?: string;
    status?: ExportStatusEnumDTO;
    /**
     * Expiration date time
     */
    expiration?: string;
    extendable?: boolean;
    result?: ExportResultDTO;
    /**
     * Size of export in bytes
     */
    filesize?: number;
    /**
     * Id of creator
     */
    createdBy?: string;
    /**
     * Id of last modifier
     */
    lastModifiedBy?: string;
    /**
     * Date of creation
     */
    created?: string;
    /**
     * Date of last modification
     */
    lastModified?: string;
}

export class ClsProceduralDocumentationExportDTO { 
    /**
     * Internal identifier of procedural documentation export
     */
    id?: string = undefined;
    /**
     * Internal identifier of business premises (location of store)
     */
    businessPremisesId?: string = undefined;
    status?: ExportStatusEnumDTO = undefined;
    /**
     * Expiration date time
     */
    expiration?: string = undefined;
    extendable?: boolean = undefined;
    result?: ExportResultDTO = undefined;
    /**
     * Size of export in bytes
     */
    filesize?: number = undefined;
    /**
     * Id of creator
     */
    createdBy?: string = undefined;
    /**
     * Id of last modifier
     */
    lastModifiedBy?: string = undefined;
    /**
     * Date of creation
     */
    created?: string = undefined;
    /**
     * Date of last modification
     */
    lastModified?: string = undefined;
}



